'use client';
import { Divider, ListItemText, MenuItem, MenuList, SwipeableDrawer } from '@mui/material';
import styles from './nav-drawer.module.scss';
import { useTranslation } from 'react-i18next';
import NextLink from 'next/link';

export interface ISwipeableNavDrawer {
  open: boolean;
  toggleDrawer: (side: string, open: boolean) => void;
}
const SwipeableNavDrawer = (props: ISwipeableNavDrawer) => {
  const { toggleDrawer, open } = props;

  const { t } = useTranslation();
  const openClose = (side: string, openDrawer: boolean) => {
    toggleDrawer(side, openDrawer);
  };
  const closeDrawer = (side: string, openDrawer: boolean) => {
    toggleDrawer(side, openDrawer);
  };

  const sideList = (side: string) => (
    <div
      className={styles.list}
      role='presentation'
      onClick={() => closeDrawer(side, false)}
      onKeyDown={() => closeDrawer(side, false)}
    >
      <MenuList sx={{ backgroundColor: 'var(--navbar-background-color)', padding: 0 }}>
        <NextLink href='/' className={styles.link}>
          <MenuItem>
            <ListItemText primary={t('navbar.home.link.text')} />
          </MenuItem>
        </NextLink>
        <Divider className={styles.divider} />
        <NextLink href='/quiz-options' className={styles.link}>
          <MenuItem>
            <ListItemText primary={t('navbar.quiz-options.link.text')} />
          </MenuItem>
        </NextLink>
        <Divider className={styles.divider} />
        <NextLink href='/learn-tables' className={styles.link}>
          <MenuItem>
            <ListItemText primary={t('navbar.learn-tables.link.text')} />
          </MenuItem>
        </NextLink>
        <Divider className={styles.divider} />
        <NextLink href='/practice' className={styles.link}>
          <MenuItem>
            <ListItemText primary={t('navbar.start-quiz.link.text')} />
          </MenuItem>
        </NextLink>
        <Divider className={styles.divider} />
        <NextLink href='/about' className={styles.link}>
          <MenuItem>
            <ListItemText primary={t('navbar.about.link.text')} />
          </MenuItem>
        </NextLink>
        <Divider className={styles.divider} />
        <NextLink href='/help' className={styles.link}>
          <MenuItem>
            <ListItemText primary={t('navbar.help.link.text')} />
          </MenuItem>
        </NextLink>
        <Divider className={styles.divider} />
      </MenuList>
    </div>
  );

  return (
    <SwipeableDrawer
      sx={{
        '& .MuiDrawer-paper': {
          backgroundColor: 'var(--navbar-background-color)',
        },
      }}
      variant='temporary'
      open={open}
      onClose={() => openClose('left', false)}
      onOpen={() => openClose('left', true)}
    >
      {sideList('left')}
    </SwipeableDrawer>
  );
};

export default SwipeableNavDrawer;
